module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"up/downgrade line":"Up/downgrade line","open product":"Open product","add new internet service":"Add new internet service","open IP setup":"Open IP setup"},"de":{"up/downgrade line":"Anschluss Up/Downgrade","open product":"Produkt öffen","add new internet service":"Neuen Internet Dienst hinzufügen","open IP setup":"IP Einstellungen öffnen"}}')
  delete Component.options._Ctor
}
